import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'petition-comments',
		path: ['/p/:slug/c', '/p/:slug/comments'],
		component: loadable(async () => import(/* webpackChunkName: "pages/petition_comments" */ './index'), {
			exportName: 'PetitionComments',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
